import { useState, useEffect } from "react";

const MOBILE_MAX_WIDTH = 1023;

export const useReducedAnimations = () => {
  const [reduced, setReduced] = useState(() => {
    if (typeof window === "undefined") return false;
    return (
      window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  });

  useEffect(() => {
    const mobileMq = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
    const motionMq = window.matchMedia("(prefers-reduced-motion: reduce)");

    const update = () => setReduced(mobileMq.matches || motionMq.matches);
    update();

    mobileMq.addEventListener("change", update);
    motionMq.addEventListener("change", update);
    return () => {
      mobileMq.removeEventListener("change", update);
      motionMq.removeEventListener("change", update);
    };
  }, []);

  return reduced;
};
